/**
 * Functionality for the maps page
 * @constructor
 */
define(['jquery', 'bing', 'c21/track', 'c21/results', 'c21/lazy', 'c21/cookie', 'c21/Collapsasaurus', 'c21/Params', 'c21/ajax', 'c21/maps/Map', 'c21/maps/Refine', 'c21/maps/SearchNav', 'c21/SchoolSearch', 'c21/SurroundingAreasMapping', 'jqueryenter', 'jqueryeffects', 'c21textdropdown', 'c21minmaxdropdown', 'jqueryui'],
   function () {
   "use strict";

   var $ = require('jquery'),
      BingMaps = require('bing'),
      Refine = require('c21/maps/Refine'),
      track = require('c21/track'),
      results = require('c21/results'),
      lazy = require('c21/lazy'),
      cookie = require('c21/cookie'),
      Collapsasaurus = require('c21/Collapsasaurus'),
      Params = require('c21/Params'),
      ajax = require('c21/ajax'),
      Map = require('c21/maps/Map'),
      SearchNav = require('c21/maps/SearchNav'),
      SchoolSearch = require('c21/SchoolSearch'),
      SurroundingAreasMapping = require('c21/SurroundingAreasMapping');

   return function (fnOnReady, fnTriggerPageReady) {
      var self = this,

         m_map,
         m_searchNav,

         m_onReady = fnOnReady,
         m_triggerPageReady = fnTriggerPageReady,

         m_bFullListViewOpen = false,

         m_refine,
         m_panelSlider,
         m_jListContainer,
         m_jMapLane,
         m_jListLane,
         m_iListWidth,
         m_schoolSearch,
         m_surroundingAreasMapping;

      function onWindowResize () {
         // TODO: Add window resizing for commercial template
         /*
         if (!m_bFullListViewOpen) {
            return;
         }

         var width = $("#LiquidBodySubsection").width();

         jFullList.find("#PropertyRowContainer > .propertyRow").width(width - 36);
         jFullList.width(width);
         */

         responsiveLeftRail();
         responsiveMapTools();
      }

      function responsiveMapTools () {
         var iBaseHeight = 155,
            jToolArea = $("#mapToolsArea"),
            jMapTools = $("#mapToolsPanel"),
            elMapTools = jMapTools.get(0),
            iClientHeight = elMapTools.clientHeight,
            iOffsetHeight = elMapTools.offsetHeight,
            iDiff = iOffsetHeight - iClientHeight,
            iHeight = iBaseHeight + iDiff;

         if (jMapTools.is(":visible")) {
            jMapTools.height(iHeight);
            jToolArea.css("bottom", iHeight);
         }
      }

      function refreshFullListImages () {
         var jListContainer = $("#PropertyRowContainer"),
            iTotalHeight = jListContainer.height(),
            iScrollTop = 0, // jListContainer.scrollTop(),
            iScrollBottom = iTotalHeight, // iScrollTop + iTotalHeight,
            jPropertyRows = jListContainer.children(".propertyRow"),
            jExtendedCounts = $("#extendedListCountsTitle"),
            bExtendedVisible = jExtendedCounts.is(":visible"),
            jImagesToLoad = $();

         jPropertyRows.each(function (i, elPropertyRow) {
            var jPropertyRow = $(elPropertyRow),
               iRowHeight = jPropertyRow.height(),
               position = jPropertyRow.position(),
               iTop = position.top,
               iBottom = iTop + iRowHeight,
               bTopInside = (iBottom < iScrollBottom) && (iBottom > iScrollTop),
               bBottomInside = (iTop < iScrollBottom) && (iTop > iScrollTop);

            if (bTopInside || bBottomInside) {
               jImagesToLoad = jImagesToLoad.add(jPropertyRow.find("img.fullListMain"));

               if (bExtendedVisible) {
                  var jLandscapeThumbs = jPropertyRow.find(".photoFlow");
                  jLandscapeThumbs.each(function () {
                     var jLandscapeThumb = $(this),
                        jImage = jLandscapeThumb.find('img');

                     // Do not preload images twice
                     if (jImage.data('preloaded') === true) {
                        return;
                     }

                     var jMainImage = jLandscapeThumb.parents(".propertyRow").find(".CardThumb img"),
                        strOldSrc = jMainImage.attr('rel');

                     jImage.hover(function () {
                        // Replace the main image with the image that was hovered over
                        jMainImage.attr('src', $(this).attr('src'));
                     }, function () {
                        jMainImage.attr('src', strOldSrc);
                     });

                     // If the image container has not wrapped
                     if (jLandscapeThumb.parent().position().top - iTop < 10) {
                        jImage.data('preloaded', true);
                        jImagesToLoad = jImagesToLoad.add(jImage);
                     }
                  });
               }
            }
         });

         if (jImagesToLoad.length > 0) {
            lazy.load(jImagesToLoad);
         }
      }

      function initPropertyExtendedView () {
         if (m_bFullListViewOpen) {
            /**
             * Code optimized for IE7-8. For speed reasons NEVER use raw class
             * selectors ex: $(".blah"), as classes are NOT indexed in IE7-8
             * and IE will be forced to slowly search the ENTIRE document
             */
            var jContainer = $("#PropertyRowContainer"),

               // Only searches direct children for a class, so this is OK
               jRows = jContainer.children(".propertyRow");

            jRows.each(function (i, el) {
               var jRow = $(el),
                  strId = "#" + jRow.attr("id"),
                  jDesc = $(strId + "propertyDescCollapse"),
                  jFeat = $(strId + 'propertyFeatures'),
                  jPropertyDetailPhotos = $(strId + "propertyDetailPhotos"),
                  jPhotoFlow = jPropertyDetailPhotos.children(".photoFlow"),
                  jLandscapeThumbs = jPhotoFlow.children(".landscapeThumbContainer");

               if (jDesc.length > 0) {
                  if (!jDesc.hasClass("collapsed")) {
                     var strExpand = jDesc.attr("expandLink");
                     jDesc.addClass("collapsed");
                     new Collapsasaurus(jDesc, 7, {
                        expandText: '&hellip;Read More',
                        expandURL: strExpand
                     });
                  }
               }

               jFeat.columns({
                  width: 200,
                  height: 110
               });

               jLandscapeThumbs.hover(function () {
                  $(this).addClass('hover');
               }, function () {
                  $(this).removeClass('hover');
               });

               jPhotoFlow.last().addClass("last");
            });
         }
      }

      /**
       * Show the Full List View
       * 
       */
      function showFullListView () {
         m_bFullListViewOpen = true;

         var iMainWidth = m_jMapLane.width(),
            fnComplete = function () {
               // Hover state on Property card needs to be re-initalized on click of full list view
               initPropertyExtendedView();
            };

         if ($.browser.msie && $.browser.version < 9.0) {
            setTimeout(function () {
               m_jListLane.css({
                  width: iMainWidth + m_iListWidth
               });
               fnComplete();
            }, 400);
         } else {
            m_jListLane.animate({
               width: iMainWidth + m_iListWidth
            }, {
               duration: 400,
               easing: 'easeOutQuad',
               complete: fnComplete
            });
         }

         m_jListLane.addClass("fullList");
         $("#bodySubsection").addClass("fullList");
         m_jMapLane.css({
            'z-index': -1
         });

         $("#extendedListCountsTitle").show();
         $("#FullListViewTopPagination").show();
         track.doEvent('Hybrid Mapping', 'Collapse/Expand', 'Show List View');
         cookie.set("LAST_LIST_VIEW", 'Open');
         refreshFullListImages();

         var jContainer = $("#PropertyRowContainer"),
            jRows = jContainer.children(".propertyRow");

         jRows.each(function (i, el) {
            var jRow = $(el),
               strId = "#" + jRow.attr("id"),
               jPropertyDetailPhotos = $(strId + "propertyDetailPhotos"),
               jPhotoFlow = jPropertyDetailPhotos.children(".photoFlow"),
               jImages = jPhotoFlow.children().length;

            if (jImages.length === 0) {
               $(strId + "propertyDescription").addClass('noImages');
            }
         });

         /*
         if ($.browser.msie && $.browser.version < 9.0) {
            m_jMapLane.css({
               opacity: 0
            });
         } else {
            m_jMapLane.animate({
               opacity: 0
            }, {
               duration: 400,
               easing: 'easeOutQuad'
            });
         }
         */

         onWindowResize();
      }

      /**
       * Hide the Full List View
       * 
       */
      function hideFullListView (fnFinish, bSkipFix) {
         m_bFullListViewOpen = false;

         $("#extendedListCountsTitle").hide();
         $("#FullListViewTopPagination").hide();
         track.doEvent('Hybrid Mapping', 'Collapse/Expand', 'Hide List View');
         cookie.set("LAST_LIST_VIEW", 'Closed');

         if ($.browser.msie && $.browser.version < 9.0) {
            m_jListLane.css({
               width: m_iListWidth
            });

            /*
            m_jMapLane.css({
               opacity: 1
            });
            */
         } else {
            // Animate the LIST
            m_jListLane.animate({
               width: m_iListWidth
            }, {
               duration: 400,
               easing: 'easeOutQuad'
            });

            // Animate the MAP
            /*
            m_jMapLane.animate({
               opacity: 1
            }, {
               duration: 400,
               easing: 'easeOutQuad'
            });
            */
         }

         m_jListLane.removeClass("fullList");
         $("#bodySubsection").removeClass("fullList");

         // When both animations are complete
         // (or immediately, if no animations are queued)
         $.when(m_jListLane.promise(), m_jMapLane.promise()).then(function () {
            m_jMapLane.css({
               'z-index': ''
            });

            // TODO: Determine if this is still needed to refresh the tiles
            /*
            if (!bSkipFix) {
               m_map.fixAfterShow();
            }
            */

            onWindowResize();

            if (fnFinish) {
               fnFinish();
            }
         });
      }

      function PanelSlider () {
         var jPanelToggle = $("#panelToggleControl"),
            jFullListToggle = $("#fullListToggleControl"),
            iListLeft = m_jListContainer.position().left,
            iMainLeft = m_jMapLane.css("left"),
            //posMain = m_jMapLane.position(),
            self = this;

         //Show the full list view based on the cookie
         var listviewcookieVal = cookie.get("LAST_LIST_VIEW");
         if (listviewcookieVal === 'Open') {
            //Show the full list view
            showFullListView();
         }

         $("#fullListHideToggleControl").click(function () {
            // Hide the full list view
            hideFullListView();
         });

         jFullListToggle.click(function () {
            // Show the full list view
            showFullListView();
         });

         self.open = function () {
            if (!jPanelToggle.hasClass("opened")) {
               return;
            }

            if (!m_map.isSurroundingAreaViewSelected()) {
               track.doEvent('Hybrid Mapping', 'Collapse/Expand', 'Show Map View');
            }

            m_jMapLane.animate({
               left: iListLeft
            }, {
               duration: 400,
               easing: 'easeOutQuad'
            });

            jPanelToggle.removeClass("opened").addClass("closed");
            jFullListToggle.hide();
            onWindowResize();
         };

         self.close = function () {
            if (jPanelToggle.hasClass("opened")) {
               return;
            }

            if (!m_map.isSurroundingAreaViewSelected()) {
               track.doEvent('Hybrid Mapping', 'Collapse/Expand', 'Hide Map View');
            }

            m_jMapLane.animate({
               left: iMainLeft
            }, {
               duration: 400,
               easing: 'easeOutQuad'
            });

            jPanelToggle.removeClass("closed").addClass("opened");
            //Bug #11222: Hide this for current release
            //jFullListToggle.show();
            onWindowResize();
         };

         jPanelToggle.click(function () {
            if (jPanelToggle.hasClass("opened")) {
               self.open();
            } else {
               self.close();
            }
         });
      }

      /**
       * Initializes the search within map checkbox
       */
      function initSearchWithinMap () {
         var jSearchWithinMap = $("#searchWithinMap"),
            strSearchEnabled = $("#searchWithinMapEnabled").val();

         // Select or Deselect search within map checkbox
         if (strSearchEnabled === 'true') {
            jSearchWithinMap.prop("checked", true);
         } else {
            jSearchWithinMap.prop("checked", false);
         }

         // Search within map needs to be disabled if drawing tool is enabled
         if ($("#drawTool").hasClass("selected")) {
            jSearchWithinMap.prop("checked", false);
            jSearchWithinMap.prop("disabled", true);
         }

         jSearchWithinMap.click(function () {
            var bChecked = $(this).prop("checked");
            if (bChecked) {
               // Refine search within map
               track.doEvent('Hybrid Mapping', 'Search Within Map', 'Select');
               m_map.lockAutoZoomToPins();
               m_map.refreshSearchWithinMap();
            } else {
               // Clear refine param
               track.doEvent('Hybrid Mapping', 'Search Within Map', 'Deselect');
               m_map.unlockAutoZoomToPins();
               m_map.refreshLocationBoundaryMap();
               results.removeLiquidMapSearchWithinMapFacet();
            }
         });
      }

      function initializeBingMaps () {
         var jMap = $("#bingMap");

         // Get the coordinates set by the server
         var portalParams = new Params(),
            strMapBoundary = portalParams.get('px'),
            locRect,
            center,
            zoom,
            lockAutoZoomToPins,
            bUseDefaultLocation = false;

         if (strMapBoundary === '' || strMapBoundary === undefined) {
            bUseDefaultLocation = true;
         } else {
            var aPoints = strMapBoundary.split(','),
               iLat1 = parseFloat(aPoints[1], 10),
               iLon1 = parseFloat(aPoints[0], 10),
               iLat2 = parseFloat(aPoints[3], 10),
               iLon2 = parseFloat(aPoints[2], 10);

            if (isNaN(iLat1) || isNaN(iLon1) || isNaN(iLat2) || isNaN(iLon2)) {
               bUseDefaultLocation = true;
            } else {
               locRect = new BingMaps.LocationRect.fromCorners(
                  new BingMaps.Location(iLat1, iLon1),
                  new BingMaps.Location(iLat2, iLon2)
               );
               lockAutoZoomToPins = true;
            }
         }

         if (bUseDefaultLocation) {
            var strLat = $("#searchLocationLatitude").val(),
               strLon = $("#searchLocationLongitude").val();

            if (strLat && strLon) {
               center = new BingMaps.Location(strLat, strLon);
               zoom = 8;
               lockAutoZoomToPins = false;
            }
         }

         // Instantiate the map
         m_map = new Map(jMap, {
            bounds: locRect,
            center: center,
            zoom: zoom,
            lockAutoZoomToPins: lockAutoZoomToPins
         });

         m_triggerPageReady(self);

         ajax.bindLoadEvent($("#BodyRightLane"), function () {
            initSearchWithinMap();
         });

         m_searchNav.setMap(m_map);
      }

      function initCardHover () {
         m_jListContainer.find(".CenterLaneCardBg.CardWrapper").each(function (i, el) {
            var jCard = $(this),
               jRow = jCard.parent();

            jRow.hover(function () {
               jCard.addClass('hover');
            }, function () {
               jCard.removeClass('hover');
            });
         });

         // Refresh the location boundary map layer on refinement
         if (m_map) {
            m_map.refreshLocationBoundaryMap();
         }
      }

      /**
       * Initializes the center lane search results
       */
      function initializeListLane () {
         m_jListContainer.animate({
            scrollTop: 0
         }, 1000, 'easeOutQuart');

         if (m_bFullListViewOpen) {
            $("#extendedListCountsTitle").show();
            $("#FullListViewTopPagination").show();
         } else {
            $("#FullListViewTopPagination").hide();
         }

         refreshFullListImages();

         initPropertyExtendedView();

         // Add the footer
         var jFoot = $('<div id="liquid-eco-footer-container">'+$("#eco-footer-container").html()+'</div>');
         m_jListContainer.append(jFoot);
         jFoot.find(".eco-page-bottom-banner").detach();

         var iSearchType = results.getSearchType(),
            SEARCH_TYPE = results.SEARCH_TYPE;

         switch (iSearchType) {
         case SEARCH_TYPE.AGENT:
            m_onReady(function () {
               m_map.updateAgentPins();
               m_searchNav.updatePins();
            });
            break;

         case SEARCH_TYPE.OFFICE:
            m_onReady(function () {
               m_map.updateOfficePins();
               m_searchNav.updatePins();
            });
            break;

         case SEARCH_TYPE.PROPERTY:
            m_onReady(function () {
               m_map.updatePropertyPins();
               m_searchNav.updatePins();
            });
            break;
         }

         initCardHover();
      }

      function interpretLassoParms (strLassoParms) {
         var aPointParms = strLassoParms.split(','),
            aPoints = [],
            point,
            latitude,
            longitude,
            i;

         // Loops by TWO
         for (i = 0; i < aPointParms.length; i = i + 2) {
            latitude = parseFloat(aPointParms[i + 1], 10);
            longitude = parseFloat(aPointParms[i], 10);

            if (isNaN(latitude) || isNaN(longitude)) {
               return false;
            }

            point = new BingMaps.Location(latitude, longitude);
            aPoints.push(point);
         }

         // We also need a redundant end point
         point = new BingMaps.Location(aPointParms[1], aPointParms[0]);
         aPoints.push(point);

         return aPoints;
      }

      function readyLasso () {
         var parms = new Params(),
            strLassoParms = parms.get('dt');

         if (strLassoParms !== undefined) {
            var aPointPath = interpretLassoParms(strLassoParms);

            // If the points are invalid
            if (aPointPath === false) {
               return;
            }

            m_map.addLassoPoly(aPointPath);
         }
      }

      // Responsive left rail
      function responsiveLeftRail () {
         var jSearchOptions = $("#morePropSearchOptionsSection"),
            jRefineFeatures = $("#refineFeaturesButton").hide();

         // Sometimes this will not be on the page
         // EX: if there are no refinements with any results
         if (jSearchOptions.length === 0) return;
         
         // Show so we can make accurate measurements with JS
         jSearchOptions.show();

         var jBodyLeftLane = $("#BodyLeftLane"),
            iLaneHeight = jBodyLeftLane.height(),

            jContainer = jSearchOptions.find(".searchOptions"),
            iSearchOptionsTop = jContainer.position().top,

            jRefineLink = $("#refineFeaturesLink").show(),
            iRefineHeight = jRefineLink.outerHeight(),

            iSpaceAvailable = iLaneHeight - iSearchOptionsTop - iRefineHeight,
            iCurrentTop = 0,

            jAllOrNothing,
            bLastRefineSection = false;

         // For all of the refinement groups
         jAllOrNothing = jSearchOptions.find('.allOrNothing');
         jAllOrNothing.each(function (i) {
            var jThis = $(this),
               iHeight;

            // We've already hit the last visible refine section
            // Don't bother with math. Just hide the section.
            if (bLastRefineSection) {
               jThis.addClass('hideAllOrNothing');
            } else {
               jThis.removeClass('hideAllOrNothing');

               // Math!
               iHeight = jThis.outerHeight();
               iCurrentTop += iHeight;

               if (iCurrentTop < iSpaceAvailable) {
                  jThis.removeClass('hideAllOrNothing');
               } else {
                  jThis.addClass('hideAllOrNothing');

                  // Flag as having hit the last refine section
                  bLastRefineSection = true;

                  // NONE are showing?
                  if (i === 0) {
                     // Hide the whole thing
                     jSearchOptions.hide();

                     // Show the "More Search Options" button
                     // (not to be confused with the link)
                     jRefineFeatures.show();

                     // Don't loop any more
                     return false;
                  } else if (i === jAllOrNothing.length) {
                     // "View All Options" isn't very useful if there
                     // is nothing more to refine the search by...
                     jRefineLink.hide();
                  }
               }
            }
         });
      }

      function resetMobileToggle () {
         var jPhoneToggle = $("#leftLaneToggle"),
            jLeft = $("#BodyLeftLane"),
            jMiddle = $("#LiquidBodySubsection");

         function mobileHideRefine () {
            jLeft.animate({'margin-left': -160});
            jMiddle.animate({'left': 0});
            jPhoneToggle.data('state', false);
         }

         function mobileShowRefine () {
            jLeft.animate({'margin-left': 0});
            jMiddle.animate({'left': 158});
            jPhoneToggle.data('state', true);
         }

         if (jPhoneToggle.data('state')) {
            mobileHideRefine();
         }

         jPhoneToggle.click(function() {
            if (jPhoneToggle.data('state')) {
               mobileHideRefine();
            } else {
               mobileShowRefine();
            }
         });
      }

      function initializeMapTools () {
         var jMapToolTip = $("#mapToolTip"),
            jMapToolTipText = $("#mapToolTipText"),
            jInstructions = $("#drawingToolInstructions"),
            // TODO: Add My Places instructions to commercial
            jMyPlaceInstructions = $("#myPlacesToolInstructions"),
            jMapToolsPanel = $("#mapToolsPanel"),
            jMapToolsButton = $("#mapToolsToggleButton"),
            jToolArea = $("#mapToolsArea"),
            iPanelHeight = 0,
            iTooltipBottomPadding = 8,

            jMyPlacesTool,
            bAnimationRunning = false,
            iDuration = 300,

            offsetTooltip = function (jTooltip, jElem) {
               jTooltip.show().css({
                  bottom: getBottom()
               });

               var jMapToolsArea = $("#mapToolsArea"),
                  iToolsWidth = jMapToolsArea.width(),
                  iToolsLeft = iToolsWidth / 2,
                  iToolWidth = jElem.width(),
                  iToolMarginLeft = parseInt(jElem.css("margin-left")) || 0,
                  iToolLeft = jElem.position().left + iToolMarginLeft,
                  iTipWidth = jTooltip.outerWidth(),
                  iTipLeft = iToolLeft + (iToolWidth / 2) - (iTipWidth / 2) - iToolsLeft;

               jTooltip.css("left", iTipLeft);
            },

            getBottom = function () {
               return iTooltipBottomPadding + jToolArea.height() + iPanelHeight;
            },

            showContent = function (jContent) {
               jMapToolsPanel.hide();
               jContent.show();
            };

         jMapToolsButton.click(function () {
            if (bAnimationRunning) {
               return;
            }

            jInstructions.removeClass('active');
            jMyPlaceInstructions.removeClass('active');

            var jButton = $(this),
               bSelected = jButton.hasClass('selected'),
               strSelector = jButton.attr('href'),
               jContent = $(strSelector);

            bAnimationRunning = true;
            jMapToolsButton.removeClass('selected');

            if (bSelected) {
               track.doEvent('Hybrid Mapping', 'Tool Bar', 'Collapse');
               iPanelHeight = 0;
               jMapToolsPanel.slideUp(iDuration, 'easeOutQuad', function () {
                  bAnimationRunning = false;
               });
               jToolArea.animate({
                  bottom: 0
               }, {
                  duration: iDuration,
                  easing: 'easeOutQuad'
               });
            } else {
               track.doEvent('Hybrid Mapping', 'Tool Bar', 'Expand');
               jMapToolsButton.removeClass('selected');
               jButton.addClass('selected');

               // Show to get accurate height reading
               jMapToolsPanel.show();
               responsiveMapTools();

               iPanelHeight = jMapToolsPanel.height();
               jToolArea.css({
                  bottom: 0
               }).animate({
                  bottom: iPanelHeight
               }, {
                  duration: iDuration,
                  easing: 'easeOutQuad'
               });

               jMapToolsPanel.hide().slideDown(iDuration, 'easeOutQuad', function () {
                  showContent(jContent);
                  bAnimationRunning = false;
               });
            }

            // Hide the heat map legend if map tools is closed
            if (!jMapToolsButton.hasClass("selected")) {
               // TODO: Move to ID selectors
               $(".overlayToolTip").hide().removeClass("shown");
            }
         });

         // TODO: Add area overlay filter
         /*
         $("#areaOverlayAge, #areaOverlayPrice, #areaOverlayIncome").hover(function () {
            $(this).addClass('hover');
         }, function () {
            $(this).removeClass('hover');
         });
         */

         function addTooltipHover (jElem, strHtml, iLeftOffset) {
            jElem.hover(function () {
               if (!jInstructions.hasClass("active")) {
                  jMyPlaceInstructions.removeClass("active");
                  jMapToolTipText.html(strHtml);
                  offsetTooltip(jMapToolTip, jElem);
               }
            }, function () {
               jMapToolTip.hide();
            });
         }

         jMyPlacesTool = $("#myPlacesTool");
         addTooltipHover(jMyPlacesTool, "MY PLACES");
         addTooltipHover($("#drawTool"), "DRAWING TOOL");
         addTooltipHover($("#prevBtn"), "PREVIOUS PAGE");
         addTooltipHover($("#nextBtn"), "NEXT PAGE");

         jInstructions.on("showTip", function () {
            jInstructions.addClass("active");
            offsetTooltip(jInstructions, $("#drawTool"));
         });
      }

      function onDocumentReady () {
         m_jListContainer = $("#listContainer");
         m_jMapLane = $("#LiquidBodyMain");
         m_jListLane = $("#BodyCenterLane");
         m_iListWidth = m_jListLane.width();

         m_panelSlider = new PanelSlider();

         m_searchNav = new SearchNav();
         m_refine = new Refine();
         m_refine.initialize(m_schoolSearch);

         initializeBingMaps();
         initializeMapTools();

         ajax.bindLoadEvent($("#searchNavTop"), resetMobileToggle);

         results.onSearchListInitialized(function () {
            var jLoadEvent = m_jListContainer.add(m_jListLane);
            ajax.bindLoadEvent(jLoadEvent, initializeListLane);
         });

         $(window).resize(refreshFullListImages);
         m_jListContainer.scroll(refreshFullListImages);

         // When the user interacts with the page
         $(document.body).click(function () {
            // Unlock the map from the initial position
            // (allowing automatic zooming to properties/agents/offices)
            m_map.unlockAutoZoomToPins();
         });
      }

      function initializeSchoolSearch () {
         m_schoolSearch = new SchoolSearch();
         m_onReady(m_schoolSearch.onPageReady);
      }

      /**
       * Initializes the surrounding areas
       */
      function initializeSurroudingAreas () {
         // Disable surrounding areas if the server has hidden it
         // EX: State seaches have no surrounding areas
         if ($("#surroundingAreasLiqMap").length === 0) {
            return;
         }

         // Initialize the flyout
         m_surroundingAreasMapping = new SurroundingAreasMapping();
         m_onReady(function (page) {
            m_surroundingAreasMapping.onPageReady(page);
            m_map.initSurroundingAreas(m_surroundingAreasMapping);
         });
      }

      function initialize () {
         initializeSchoolSearch();
         initializeSurroudingAreas();
         $(document).ready(onDocumentReady);
         $(window).resize(onWindowResize);
         m_onReady(readyLasso);
         results.setPage(self);
      }

      self.closeCenterLane = function (fnFinish, bSkipFix) {
         if (m_bFullListViewOpen) {
            hideFullListView(function () {
               m_panelSlider.open();
               if (fnFinish) {
                  fnFinish();
               }
            }, bSkipFix);
         } else {
            m_panelSlider.open();
            if (fnFinish) {
               fnFinish();
            }
         }
      };

      self.openCenterLane = function () {
         m_panelSlider.close();
      };

      self.getMap = function () {
         return m_map;
      };

      self.initialize = function () {
         initialize();
      };
   };
});
